/** Loadout picked on the ready screen before each round. */

import { assetUrl } from "../assetUrl";

/** Number of ability slots offered (3x2 grid). */
export const ABILITY_COUNT = 6;
/** How many you must pick before you can ready up. */
export const ABILITY_PICKS = 2;

export const ABILITY_SNEAK_PEEK = 0;
export const ABILITY_CACTUS_SUIT = 1;
export const ABILITY_SHOTGUN = 2;
export const ABILITY_COWBOY_DUMMY = 3;
export const ABILITY_DOUBLE_PACE = 4;
export const ABILITY_FLASHBANG = 5;

/** Brief fog lift duration for Sneak Peek (ms). */
export const SNEAK_PEEK_MS = 1000;
/** Fade in / fade out edge length — keep short so most of the second is clear. */
export const SNEAK_PEEK_FADE_MS = 120;

/** Pellets fired per shotgun blast. */
export const SHOTGUN_PELLETS = 5;
/** Shotgun pellet speed (revolver is 1500). */
export const SHOTGUN_SPEED = 1265;
/** Shotgun tracer length in px (revolver is 280). */
export const SHOTGUN_TRACER_LEN = 90;

/** How long the cowboy dummy takes to inflate to full size (ms). */
export const DUMMY_INFLATE_MS = 900;

/**
 * Lerp speed while Double Pace is active (px/s).
 * Two 45px paces at 130 ≈ 0.69s, so both anims fit in a countdown second.
 */
export const DOUBLE_PACE_LERP_SPEED = 130;

/** Flashbang flight time before the white-out (ms). */
export const FLASHBANG_FLIGHT_MS = 500;
/** How long the screen stays fully white after the bang (ms). */
export const FLASHBANG_HOLD_MS = 250;
/** White screen fade-out duration after the hold (ms). */
export const FLASHBANG_FADE_MS = 500;

export interface AbilityDef {
  id: number;
  title: string;
  description: string;
  /** Optional icon under /public (shown instead of the slot number). */
  icon?: string;
}

/** Ability catalog — ids match the ready-screen grid order. */
export const ABILITIES: AbilityDef[] = [
  {
    id: ABILITY_SNEAK_PEEK,
    title: "Sneak Peek",
    description:
      "Allows you to sneak a peek at your opponents no-good-doings halfway through the countdown.",
    icon: assetUrl("sprites/sneak_peek.png"),
  },
  {
    id: ABILITY_CACTUS_SUIT,
    title: "Cactus Suit",
    description:
      "At the start of the countdown, slip into a cactus suit to fool your opponent. Don't worry, it's more comfortable than it sounds.",
    icon: assetUrl("sprites/cactus_suit.png"),
  },
  {
    id: ABILITY_SHOTGUN,
    title: "Shotgun",
    description:
      "Replace your trusty revolver with a sawed-off shotgun. Who needs to aim when you have a shotgun?",
    icon: assetUrl("sprites/shotgun.png"),
  },
  {
    id: ABILITY_COWBOY_DUMMY,
    title: "Cowboy Dummy",
    description: "Set up an inflatable dummy that looks just like you, well almost. Press 'space' to use it.",
    icon: assetUrl("sprites/cowboy_dummy.png"),
  },
  {
    id: ABILITY_DOUBLE_PACE,
    title: "Double Pace",
    description:
      "Take two paces instead of one to get around quicker. Is it cheating? Probably.",
    icon: assetUrl("sprites/double_pace.png"),
  },
  {
    id: ABILITY_FLASHBANG,
    title: "Flashbang",
    description:
      "Throw a flashbang at the last second to blind your opponent briefly. Okay this is definitely cheating.",
    icon: assetUrl("sprites/flashbang.png"),
  },
];
